import React from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
// for react-day-picker translations
// https://react-day-picker-v7.netlify.app/docs/localization
import MomentLocaleUtils from 'react-day-picker/moment';
import { injectIntl } from 'react-intl';

const DateFilterCalendar = ({ className, intl, ...props }) => {
  return (
    <DayPicker
      className={className}
      {...props}
      localeUtils={MomentLocaleUtils}
      locale={intl.locale}
    />
  );
};

export default injectIntl(DateFilterCalendar);
